<!-- 邀请弹窗 -->
<script lang="ts" setup>
// 与登录弹窗统一使用 UModal
const inviteModalStore = useInviteModalStore()

const inviteText
  = 'Incredible AI for making music! Endless creativity. ✨ http://www.kjlsdufosailk.com/invite/@username'

const copy = async () => {
  try {
    await navigator.clipboard.writeText(inviteText)
  } catch {
    // ignore
  }
}
</script>

<template>
  <UModal
    v-model:open="inviteModalStore.isOpenInviteModal"
    :ui="{
      overlay: 'bg-[#101012B2] backdrop-blur-[3px]',
      content: 'w-[calc(100%-32px)] md:w-[700px] max-w-max bg-[#2D2D39] rounded-[16px] ring-[none]'
    }"
  >
    <template #content>
      <div class="relative flex flex-col gap-y-[32px] w-full h-full font-['Roboto'] p-[32px]">
        <!-- 关闭按钮（与登录弹窗风格一致） -->
        <div
          class="absolute top-[16px] right-[16px] flex items-center justify-center w-[34px] h-[34px] cursor-pointer before:content-[''] before:absolute before:w-[20px] before:h-[2px] before:bg-[#8888A1] before:rotate-45 before:rounded-[20px] after:content-[''] after:absolute after:w-[20px] after:h-[2px] after:bg-[#8888A1] after:-rotate-45 after:rounded-[20px]"
          @click="inviteModalStore.closeInviteModal()"
        />

        <!-- 标题 -->
        <div class="flex flex-col gap-y-[4px]">
          <p class="text-[24px] text-[#FFFFFF] leading-[28px]">
            Share the Magic with your friends
          </p>
          <p class="text-[14px] text-[#8888A1] leading-[20px]">
            Invite friends to experience what you love and we'll thank you both
          </p>
        </div>

        <!-- 规则列表 -->
        <ul class="list-disc pl-[32px] text-[16px] text-[#FFFFFF] leading-[24px]">
          <li>
            Get a 100 credits bonus when your friend successfully registers as a new user and generate 10 songs !
          </li>
          <li>When they subscribe, you'll receive 250 credits to continue your journey.</li>
          <li>Your reward credits will be distributed within 24 hours.</li>
        </ul>

        <!-- 邀请链接 + 复制 -->
        <div class="flex items-center justify-between gap-[12px] bg-[#262635] border border-[#5E5E77] p-[12px] rounded-[8px]">
          <div class="text-[14px] text-[#E7E7EC] leading-[20px] break-all">
            Incredible AI for making music! Endless creativity. ✨
            <br>
            http://www.kjlsdufosailk.com/invite/@username
          </div>
          <UButton
            icon="material-symbols:content-copy-outline-rounded"
            label="Copy"
            :ui="{
              base: 'flex items-center gap-[8px] bg-[#383847] hover:bg-[#383847] active:bg-[#383847] border-none px-[12px] py-[8px] rounded-[8px] cursor-pointer',
              label: 'text-[14px] text-[#E7E7EC] leading-[16px]',
              leadingIcon: 'size-[16px] text-[#E7E7EC]'
            }"
            @click="copy"
          />
        </div>

        <!-- 底部统计 -->
        <div class="flex gap-x-[16px]">
          <div class="flex flex-col gap-[4px] p-[8px]">
            <div class="text-[16px] text-[#FFFFFF] leading-[20px]">
              0
            </div>
            <div class="text-[12px] text-[#B8B8C7] leading-[16px]">
              Friends Invited
            </div>
          </div>
          <div class="flex flex-col gap-[4px] p-[8px]">
            <div class="text-[16px] text-[#FFFFFF] leading-[20px]">
              0
            </div>
            <div class="text-[12px] text-[#B8B8C7] leading-[16px]">
              Credits Earned
            </div>
          </div>
        </div>
      </div>
    </template>
  </UModal>
</template>
